// extracted by mini-css-extract-plugin
module.exports = {"faceContainer":"Face_faceContainer__30HHN","mirror":"Face_mirror__2op2m","face":"Face_face__2g4jA","shea":"Face_shea__1SwQQ","liam":"Face_liam__1e5ts","matt":"Face_matt__2PFw_"};